import dynamic from "next/dynamic";

import { insertTagsInCloudinaryUrl } from "utils/image";
import { generateBlazeSlides } from "utils/sliders";
import styles from "./ImageElement.module.scss";
const BlazeSlider = dynamic(
  () => import("components/Slider/BlazeSlider/BlazeSlider")
);
const CldImage = dynamic(() =>
  import("next-cloudinary").then((mod) => mod.CldImage)
);
const Image = dynamic(() => import("next/image"));

export default function ImageElement({ images, slider, type, aspectRatio }) {
  const sizes = `(min-width: 320px) 100vw,
          (min-width: 992px) 55vw,
          100vw`;

  let element = <></>;

  // const height = images?.data[0].attributes.height ?? null;

  if (type === "single" && !!images) {
    if (aspectRatio) {
      const aspectRatioArray = aspectRatio.split("/");
      const numericAspectRatio = aspectRatioArray[0] / aspectRatioArray[1];
      const width = images[0].data?.attributes.width ?? null;

      const cloudinaryUrl = insertTagsInCloudinaryUrl(
        images[0].data?.attributes.url,
        `w_${width},c_fill,ar_${numericAspectRatio}`
      );

      element = (
        <div
          className={`${styles.imageWrapper}`}
          style={{ aspectRatio: aspectRatio }}
        >
          <Image
            src={cloudinaryUrl}
            alt={images[0].data.attributes.alternativeText}
            // width={images.data[0].attributes.width}
            // height={images.data[0].attributes.height}
            // crop={`w_${width},h_auto,lfill,ar_${numericAspectRatio}`}
            fill
            // preserveTransformations
            sizes={sizes}
          />
        </div>
      );
    } else {
      element = (
        <div
          className={`${styles.imageWrapper}`}
          style={{ aspectRatio: aspectRatio }}
        >
          <CldImage
            src={images.data[0].attributes.url}
            alt={images.data[0].attributes.alternativeText}
            // width={images.data[0].attributes.width}
            // height={images.data[0].attributes.height}
            // crop={`w_${width},h_auto,lfill,ar_${numericAspectRatio}`}
            fill
            preserveTransformations
            sizes={sizes}
          />
        </div>
      );
    }
  }

  if (type === "slider" && !!slider && !!slider.length) {
    const width = slider[0].sliderImageLarge.data.attributes.width;
    const slides = generateBlazeSlides({
      slides: slider,
      props: {
        sizes: sizes,
        aspectRatio: aspectRatio,
      },
    });

    const blazeSlider = (
      <div
        style={{
          maxWidth: `${width ? `${width}px` : "100%"}`,
          aspectRatio: `${aspectRatio ?? "unset"}`,
        }}
      >
        <BlazeSlider>{slides}</BlazeSlider>
      </div>
    );
    element = blazeSlider;
  }

  return element;
}
